import { getCookie, getAccessToken } from "../../../helpers/cookieHelper";
import { API_URL } from '../../../constants';
const axios = require("axios");

export const getProjectID = async () => {
    let erp_access_token = getCookie('access_token')
    let erp_token_type = getCookie('token_type')
    let headerConfig = {
        headers: {
            authorization: erp_token_type + ' ' + erp_access_token,
            'Content-Type': 'application/json',
        },
    }
    //   console.log(erp_access_token)
    if (erp_access_token != null) {
        let url = API_URL + 'api/fetchallprojectInfo';

        try {
            let response = await axios.get(url, headerConfig)


            if (response.status === 200) {
                var dataObject = response.data.object
                console.log(dataObject)

                return dataObject;


            } else {

                return []
            }
        }
        catch (error) {


            return []


        }
    } else {
        const resp = await getAccessToken()
        if (resp) {
            this.getProjectID()
        }
    }

}

export const getPriorityID = async () => {
    let erp_access_token = getCookie('access_token')
    let erp_token_type = getCookie('token_type')
    let headerConfig = {
        headers: {
            authorization: erp_token_type + ' ' + erp_access_token,
            'Content-Type': 'application/json',
        },
    }
    //  console.log(erp_access_token)
    if (erp_access_token != null) {
        try {
            let response = await axios.get(API_URL + 'api/fetchallticketpriority', headerConfig)


            if (response.status === 200) {
                let dataObject = response.data.object
                return dataObject
            } else {
                return []
            }
        }
        catch (error) {


            //alert("Internal server error")l
            let response = error['response']
            if (response !== undefined) {
                if (response.data.status === 403) {
                    this.messager.alert({
                        title: 'Error',
                        icon: 'error',
                        reload: false,
                        msg: response.data.message,
                    }) //Backend Validation Error i.e. 403
                } else {
                    this.messager.alert({
                        title: 'Error',
                        msg: 'UnCaught Error',
                        icon: 'error',
                        reload: false,
                    })//uncaught Backend Error i.e. 500
                }
            } else {
                this.messager.alert({
                    title: 'Error',
                    icon: 'error',
                    msg: 'Internal Server Error',
                    reload: false
                })// caused due to syntax error in front end
            }
            return []
        }
    } else {
        const resp = await getAccessToken()
        if (resp) {
            this.getPriorityID()
        }
    }
}

export const getTicketTypeId = async () => {
    let erp_access_token = getCookie('access_token')
    let erp_token_type = getCookie('token_type')
    let headerConfig = {
        headers: {
            authorization: erp_token_type + ' ' + erp_access_token,
            'Content-Type': 'application/json',
        },
    }
    if (erp_access_token !== null) {
        try {
            let response = await axios.get(API_URL + 'api/fetchalltickettype', headerConfig)

            if (response.status === 200) {

                let dataObject = response.data.object
                return dataObject
            } else {
                return []

            }
        }
        catch (error) {
            //console.log(error)

            //alert("Internal server error")l
            let response = error['response']
            if (response !== undefined) {
                if (response.data.status === 403) {
                    this.messager.alert({
                        title: 'Error',
                        icon: 'error',
                        reload: false,
                        msg: response.data.message,
                    }) //Backend Validation Error i.e. 403
                } else {
                    this.messager.alert({
                        title: 'Error',
                        msg: 'UnCaught Error',
                        icon: 'error',
                        reload: false,
                    })//uncaught Backend Error i.e. 500
                }
            } else {
                this.messager.alert({
                    title: 'Error',
                    icon: 'error',
                    msg: 'Internal Server Error',
                    reload: false
                })// caused due to syntax error in front end
            }
            return []
        }
    } else {
        const resp = await getAccessToken()
        if (resp) {
            this.getTicketTypeId()
        }
    }
}

export const getTicketStatusId = async () => {
    let erp_access_token = getCookie('access_token')
    let erp_token_type = getCookie('token_type')
    let headerConfig = {
        headers: {
            authorization: erp_token_type + ' ' + erp_access_token,
            'Content-Type': 'application/json',
        },
    }
    if (erp_access_token !== null) {
        try {
            let response = await axios.get(API_URL + 'api/fetchallticketstatustype', headerConfig)


            if (response.status === 200) {

                let dataObject = response.data.object
                return dataObject
            } else {
                return []
            }
        }
        catch (error) {
            //console.log(error)

            //alert("Internal server error")l
            let response = error['response']
            if (response !== undefined) {
                if (response.data.status === 403) {
                    this.messager.alert({
                        title: 'Error',
                        icon: 'error',
                        reload: false,
                        msg: response.data.message,
                    }) //Backend Validation Error i.e. 403
                } else {
                    this.messager.alert({
                        title: 'Error',
                        msg: 'UnCaught Error',
                        icon: 'error',
                        reload: false,
                    })//uncaught Backend Error i.e. 500
                }
            } else {
                this.messager.alert({
                    title: 'Error',
                    icon: 'error',
                    msg: 'Internal Server Error',
                    reload: false
                })// caused due to syntax error in front end
            }
            return []
        }
    } else {
        const resp = await getAccessToken()
        if (resp) {
            this.getTicketStatusId()
        }
    }
}

export const getAssigneId = async () => {
    let erp_access_token = getCookie('access_token')
    let erp_token_type = getCookie('token_type')
    let headerConfig = {
        headers: {
            authorization: erp_token_type + ' ' + erp_access_token,
            'Content-Type': 'application/json',
        },
    }
    if (erp_access_token !== null) {
        try {
            let response = await axios.get(API_URL + 'api/users', headerConfig)
            if (response.status === 200) {
                console.log(response)
                let dataObject = response.data

                return dataObject
            } else {
                return []
            }
        }
        catch (error) {
            //console.log(error)

            //alert("Internal server error")l
            let response = error['response']
            if (response !== undefined) {
                if (response.data.status === 403) {
                    this.messager.alert({
                        title: 'Error',
                        icon: 'error',
                        reload: false,
                        msg: response.data.message,
                    }) //Backend Validation Error i.e. 403
                } else {
                    this.messager.alert({
                        title: 'Error',
                        msg: 'UnCaught Error',
                        icon: 'error',
                        reload: false,
                    })//uncaught Backend Error i.e. 500
                }
            } else {
                this.messager.alert({
                    title: 'Error',
                    icon: 'error',
                    msg: 'Internal Server Error',
                    reload: false
                })// caused due to syntax error in front end
            }
            return []
        }
    } else {
        const resp = await getAccessToken()
        if (resp) {
            this.getAssigneId()
        }
    }
}